import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function OpeningLead() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 bg-brand-bg-dark border-b border-brand-gold/10" data-id="element-226">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg prose-invert mx-auto text-center" data-id="element-228">
          <p className="text-2xl sm:text-3xl text-gray-300 font-medium leading-relaxed mb-8" data-id="element-229">
            {t('opening.p1')}
          </p>

          <p className="text-xl sm:text-2xl text-gray-400 mb-8" data-id="element-230">
            {t('opening.p2')}
          </p>

          <blockquote className="text-3xl sm:text-4xl font-heading font-bold text-brand-gold italic my-12 border-l-4 border-brand-gold pl-6 text-left" data-id="element-231">
            {t('opening.quote')}
          </blockquote>

          <p className="text-xl sm:text-2xl text-gray-300 mb-8 text-left" data-id="element-232">
            {t('opening.p3')}
          </p>

          <p className="text-xl sm:text-2xl text-gray-300 mb-12 text-left" data-id="element-233">
            {t('opening.p4')}
          </p>

          <div className="inline-block bg-brand-red/10 border border-brand-red/30 px-8 py-4 rounded-md" data-id="element-234">
            <p className="text-3xl sm:text-4xl font-heading font-bold text-brand-red m-0 uppercase tracking-widest" data-id="element-235">
              {t('opening.highlight')}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}